export const howItWorkUpscale = [
	{
		icon: '🖼',
		title: 'howItWorkData_title1',
		subtitle: 'howItWorkData_subtitle1',
	},
	{
		icon: '✨',
		title: 'howItWorkData_title2',
		subtitle: 'howItWorkData_subtitle2',
	},
	{
		icon: '💁‍♀️',
		title: 'howItWorkData_title3',
		subtitle: 'howItWorkData_subtitle3',
	},
	{
		icon: '🤘',
		title: 'howItWorkData_title4',
		subtitle: 'howItWorkData_subtitle4',
	},
];
